import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Empty, Row, Skeleton } from 'antd'

import getEligibleEmployeeRenewalTemplate from 'core/application/adminDashboard/benefitRenewal/notifyEmployees/eligibleEmployeesTemplate'
import getNonEligibleEmployeeRenewalTemplate from 'core/application/adminDashboard/benefitRenewal/notifyEmployees/nonEligibleEmployeesTemplate'
import { TemplateEmail } from 'core/application/adminDashboard/managePeople/invitations/TemplateEmail'

import Card from 'common/components/dataDisplay/Card'

import { queryRequest } from 'common/RequestUtils'

interface IFrame {
  __html: string
}

const initialFrameValue: IFrame = {
  __html: '',
}

const RenewalSampleEmail: React.FC = () => {
  const [eeTemplate, setEeTemplate] = useState<IFrame>(initialFrameValue)
  const [nonEeTemplate, setNonEeTemplate] = useState<IFrame>(initialFrameValue)
  const [loaddingEE, setLodadingEE] = useState<boolean>(true)
  const [loaddingNonEE, setLodadingNonEE] = useState<boolean>(true)
  const [eeTemplateNotFound, setEeTemplateNotFound] = useState<boolean>(false)
  const [nonEeTemplateNotFound, setNonEeTemplateNotFound] = useState<boolean>(false)
  const { t: translate } = useTranslation()

  const getEeTemplate = async () => {
    const result: TemplateEmail = await queryRequest(() => getEligibleEmployeeRenewalTemplate())
    result && result.htmlContent ? setEeTemplate({ __html: result.htmlContent }) : setEeTemplateNotFound(true)
    setLodadingEE(false)
  }
  const getNonEeTemplate = async () => {
    const result: TemplateEmail = await queryRequest(() => getNonEligibleEmployeeRenewalTemplate())
    result && result.htmlContent ? setNonEeTemplate({ __html: result.htmlContent }) : setNonEeTemplateNotFound(true)
    setLodadingNonEE(false)
  }

  const EEtemplate: React.FC = () => {
    return eeTemplateNotFound ? (
      <div>
        <Empty />
      </div>
    ) : (
      <div dangerouslySetInnerHTML={eeTemplate} />
    )
  }

  const NonEEtemplate: React.FC = () => {
    return nonEeTemplateNotFound ? (
      <div>
        <Empty />
      </div>
    ) : (
      <div dangerouslySetInnerHTML={nonEeTemplate} />
    )
  }

  useEffect(() => {
    getEeTemplate()
    //getNonEeTemplate();
  }, [])

  return (
    <>
      <Row>
        <Col>
          <Card title={translate('admin-dashboard.home.renewal-sample-ee-email')}>
            <Skeleton loading={loaddingEE}>
              <EEtemplate />
            </Skeleton>
          </Card>
        </Col>
      </Row>
      {/* <Row className="mt-24">
        <Col>
          <Card title={translate("admin-dashboard.home.renewal-sample-non-ee-email")}>
            <Skeleton loading={loaddingNonEE}>
              <NonEEtemplate />
            </Skeleton>
          </Card>
        </Col>
      </Row> */}
    </>
  )
}

export default RenewalSampleEmail
